import { ColDef } from "ag-grid-community";
import { CustomCellRendererProps } from "ag-grid-react";
import {
  KubernetesAiSavingsOpportunity,
  TaskStatus,
} from "@/services/cloudchipr.api";
import {
  getSavingsOpportunitiesTableColumns,
  savingsOpportunityAccountColumnField,
  savingsOpportunityBillingCostColumnField,
  savingsOpportunityCloudProviderColumnField,
  savingsOpportunityForecastEOMColumnField,
  savingsOpportunityResourceArnColumnField,
} from "@/components/pages/savings-opportunities/components/savingsOpportunitiesTableColumns";
import { SavingsOpportunitiesInnerHeader } from "@/components/pages/savings-opportunities/components/header/SavingsOpportunitiesInnerHeader";
import { AccountInfoData } from "@/components/common/AccountInfoData";

export const getAiKubernetesRecommendationsTableColumnsSelector = (
  taskStatuses?: TaskStatus[],
  enableBillingCostAndForecastedEOMForOpportunities?: boolean,
): ColDef[] => {
  return getSavingsOpportunitiesTableColumns(
    taskStatuses,
    enableBillingCostAndForecastedEOMForOpportunities,
  )
    .filter(
      ({ field }) =>
        field !== savingsOpportunityBillingCostColumnField &&
        field !== savingsOpportunityForecastEOMColumnField &&
        field !== savingsOpportunityResourceArnColumnField &&
        field !== savingsOpportunityCloudProviderColumnField,
    )
    .map((col) => {
      if (col.field === savingsOpportunityAccountColumnField) {
        return aiKubernetesRecommendationClusterColumn;
      }

      return col;
    });
};

const aiKubernetesRecommendationClusterColumn: ColDef<KubernetesAiSavingsOpportunity> =
  {
    field: "cluster.name",
    headerName: "Cluster",
    headerComponentParams: {
      innerHeaderComponent: SavingsOpportunitiesInnerHeader,
    },
    cellRenderer: ({ data }: CustomCellRendererProps) => {
      const cluster = data?.cluster;

      if (!cluster) {
        return;
      }

      return (
        <AccountInfoData
          provider="kubernetes"
          accountId={cluster?.cluster_id}
          accountName={cluster?.name}
        />
      );
    },
  };
